import { useContext, useCallback, useLayoutEffect, useState } from 'react'
import { stringify } from 'qs'
import { AppContext, RouterContext } from '../../contexts'
import { clientFrontendUri } from '../../constants/env'

const useToggleGuestSignup = () => {
  const { customerProfileId, customerPublicKey } = useContext(AppContext)
  const { showIframe, setShowIframe, setIframeSrc } = useContext(RouterContext)
  const [redirectParams, setRedirectParams] = useState({})

  const generateRedirectUrl = useCallback(() => {
    if (redirectParams.redirectUrl) {
      return redirectParams.redirectUrl
    }

    const redirectUrlSearchParams = new URLSearchParams(window.location.search)
    Object.keys(redirectParams).forEach(k => {
      if (redirectParams[k] == null) return

      redirectUrlSearchParams.set(k, redirectParams[k])
    })

    const url = encodeURIComponent(
      window.location.origin +
        window.location.pathname +
        `?${redirectUrlSearchParams.toString()}`
    )

    return url
  }, [
    redirectParams.expandModal,
    redirectParams.focusTab,
    redirectParams.focusTarget,
    redirectParams.redirectUrl,
  ])

  useLayoutEffect(() => {
    const params = {
      customerPublicKey,
      customerProfileId,
      redirectUrl: generateRedirectUrl(),
    }

    let src = `${clientFrontendUri}/sign-up`

    src += stringify(params, {
      addQueryPrefix: true,
    })

    setIframeSrc(src)
  }, [customerProfileId, customerPublicKey, setIframeSrc, generateRedirectUrl])

  const toggle = useCallback(
    (props = {}) => {
      const { expandModal, focusTab, focusTarget, redirectUrl } = props
      setRedirectParams({
        expandModal,
        focusTab,
        focusTarget,
        redirectUrl,
      })
      setShowIframe(!showIframe)
    },
    [setShowIframe, showIframe]
  )

  return toggle
}

export default useToggleGuestSignup
